import React from 'react';
import { Combobox } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/solid';

interface AdminPickerProps {
    admins: string[];
    currentUserEmails: string[];
    filteredUsers: { id: string; email: string; name: string }[];
    handleUpdateSuperAdmins: (value: string[]) => void;
    handleRemoveAdmin: (admin: string) => void;
}

const AdminPicker: React.FC<AdminPickerProps> = ({
    admins,
    currentUserEmails,
    filteredUsers,
    handleUpdateSuperAdmins,
    handleRemoveAdmin,
}) => {
    return (
        <Combobox value={admins} onChange={handleUpdateSuperAdmins} multiple>
            <div className="flex flex-wrap items-center gap-2 mb-2">
                {admins.map((admin) => (
                    <div
                        key={admin}
                        className="flex items-center gap-1 text-sm text-gray-700 bg-gray-100 px-2 py-1 rounded"
                    >
                        {admin}
                        {!currentUserEmails.includes(admin) && (
                            <button onClick={() => handleRemoveAdmin(admin)}>
                                <XMarkIcon className="h-4 w-4 text-gray-500 hover:text-red-500" />
                            </button>
                        )}
                    </div>
                ))}
                <Combobox.Input
                    className="min-w-[150px] flex-1 border border-gray-300 rounded-md px-3 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                    placeholder="Search for user to add"
                />
            </div>
            <Combobox.Options className="mt-2 max-h-60 w-full overflow-auto rounded-md border border-gray-300 bg-white shadow-lg">
                {filteredUsers
                    .filter((user) => !currentUserEmails.includes(user.email))
                    .map((user) => (
                        <Combobox.Option
                            key={user.id}
                            value={user.email}
                            className="cursor-pointer px-4 py-2 hover:bg-blue-100 text-sm"
                        >
                            {user.name}
                        </Combobox.Option>
                    ))}
            </Combobox.Options>
        </Combobox>
    );
};

export default AdminPicker;